// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Normal document flow: title, then hint, then count, then list.
   Do not position:absolute any header/list block — that is what stacked
   the Wonder crop (title / hint / cards on top of each other). */

.sol,
.sol-head,
.sol-list,
.sol-empty,
.sol-title,
.sol-hint,
.sol-count {
  position: static;
}

.sol {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--paper);
}

.sol-head {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px 20px 12px;
  flex: 0 0 auto;
}

.sol-list,
.sol-empty {
  flex: 1 1 auto;
}

.sol-title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 400;
  font-size: 2rem;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.sol-hint {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.sol-count {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.sol-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.sol-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 20px;
  border-top: 1px solid var(--rule-soft);
}

.sol-card__open {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.sol-card__meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sol-card__rol {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink-3);
}

.sol-card__badge {
  font-family: var(--font-mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 1px solid var(--cream-deep);
  color: var(--cream-deep);
  padding: 2px 6px;
}

.sol-card__meta svg {
  margin-left: auto;
  color: var(--ink-3);
}

.sol-card__party {
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--ink);
}

.sol-card__kind {
  font-size: 0.9rem;
  color: var(--ink-2);
}

.sol-card__price {
  margin-top: 4px;
  font-family: var(--font-mono);
  font-size: 1.15rem;
  color: var(--ink);
}

.sol-card__due {
  font-size: 0.85rem;
  color: var(--ink-3);
}

.sol-card__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.sol-card__actions .btn {
  width: 100%;
}

.sol-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 72px 32px 24px;
}

.sol-empty__icon {
  width: 48px;
  height: 48px;
  border: 1px solid var(--rule);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink-3);
}

.sol-empty__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 500;
}

.sol-empty__body {
  margin: 0;
  max-width: 260px;
  color: var(--ink-2);
  font-size: 0.95rem;
}

.sol-status {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  padding: 32px 20px;
}

.sol .sol-status {
  flex-direction: column;
  gap: 16px;
}

.sol-status__body {
  margin: 0;
  max-width: 260px;
  text-align: center;
  color: var(--ink-2);
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/solicitudes/SolicitudesInbox.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Normal document flow: title, then hint, then count, then list.\n   Do not position:absolute any header/list block — that is what stacked\n   the Wonder crop (title / hint / cards on top of each other). */\n\n.sol,\n.sol-head,\n.sol-list,\n.sol-empty,\n.sol-title,\n.sol-hint,\n.sol-count {\n  position: static;\n}\n\n.sol {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  background: var(--paper);\n}\n\n.sol-head {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 24px 20px 12px;\n  flex: 0 0 auto;\n}\n\n.sol-list,\n.sol-empty {\n  flex: 1 1 auto;\n}\n\n.sol-title {\n  margin: 0;\n  font-family: var(--font-display);\n  font-weight: 400;\n  font-size: 2rem;\n  line-height: 1.2;\n  letter-spacing: -0.03em;\n  color: var(--ink);\n}\n\n.sol-hint {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.sol-count {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.sol-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.sol-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px 20px;\n  border-top: 1px solid var(--rule-soft);\n}\n\n.sol-card__open {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n}\n\n.sol-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sol-card__rol {\n  font-family: var(--font-mono);\n  font-size: 12px;\n  color: var(--ink-3);\n}\n\n.sol-card__badge {\n  font-family: var(--font-mono);\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border: 1px solid var(--cream-deep);\n  color: var(--cream-deep);\n  padding: 2px 6px;\n}\n\n.sol-card__meta svg {\n  margin-left: auto;\n  color: var(--ink-3);\n}\n\n.sol-card__party {\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: var(--ink);\n}\n\n.sol-card__kind {\n  font-size: 0.9rem;\n  color: var(--ink-2);\n}\n\n.sol-card__price {\n  margin-top: 4px;\n  font-family: var(--font-mono);\n  font-size: 1.15rem;\n  color: var(--ink);\n}\n\n.sol-card__due {\n  font-size: 0.85rem;\n  color: var(--ink-3);\n}\n\n.sol-card__actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.sol-card__actions .btn {\n  width: 100%;\n}\n\n.sol-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 72px 32px 24px;\n}\n\n.sol-empty__icon {\n  width: 48px;\n  height: 48px;\n  border: 1px solid var(--rule);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ink-3);\n}\n\n.sol-empty__title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n\n.sol-empty__body {\n  margin: 0;\n  max-width: 260px;\n  color: var(--ink-2);\n  font-size: 0.95rem;\n}\n\n.sol-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  padding: 32px 20px;\n}\n\n.sol .sol-status {\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sol-status__body {\n  margin: 0;\n  max-width: 260px;\n  text-align: center;\n  color: var(--ink-2);\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
